export default __webpack_public_path__ + "static/media/diary.70b8c401.png";